import { useEffect, useMemo, useState } from 'react';

interface UsePermissionProps {
  type: 'microphone' | 'camera';
}

type PermissionStateExtended = 'granted' | 'denied' | 'prompt' | 'unsupported' | '';

const usePermission = ({ type }: UsePermissionProps) => {
  const [permission, setPermission] = useState<PermissionStateExtended>('');

  useEffect(() => {
    if (!navigator.permissions || !navigator.mediaDevices) {
      setPermission('unsupported');
      return;
    }

    const permissionName = type as PermissionName;

    navigator.permissions
      .query({ name: permissionName })
      .then((result) => {
        setPermission(result.state as PermissionStateExtended);

        // eslint-disable-next-line no-param-reassign
        result.onchange = () => {
          setPermission(result.state as PermissionStateExtended);
        };
      })
      .catch(() => {
        setPermission('prompt'); // fallback if query fails
      });
  }, [type]);

  return useMemo(() => [permission, setPermission] as const, [permission]);
};

export default usePermission;
